<template>
  <div>
    <Header/>
    <div class="notFound">
      <img src="../../../static/img/magnifying-glass.svg" class="logo" alt="logo de uma lupa preta">
      <div class="text-center col-sm-12">
        <h1>Você esta perdido?</h1>
        <h4>A página que você procura não existe.</h4>
        <router-link to="/biomanager/" class="vertical-5p lead">Ir para Home.</router-link>
      </div>
    </div>
  </div>
</template>
<script>
import Header from '../components/Header'

export default {
  name: 'NotFound',
  components: {Header}
}
</script>

<style scoped>
.notFound {
  padding: 10em;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.logo {
  max-width: 10rem;
  margin-top: -6px;
  margin-right: 10px;
  vertical-align: middle;
  opacity: 70%;
}
</style>



// WEBPACK FOOTER //
// 404.vue?c327100c